import { WixIcons } from '../../../components/common';
import { Layout } from '../../../constants/Layout';

export const LayoutSwitcherIcons = {
  [Layout.Gallery]: WixIcons.LayoutGallery,
  [Layout.List]: WixIcons.LayoutList,
};
